export const formConf = {
  formRef: 'elForm',
  size: 'small',
  labelPosition: 'right',
  labelWidth: 100,
  gutter: 15,
  disabled: false,
  span: 24,
  formBtns: true
}

/**
 * label: 组件名称，拖拽后的表单标签名称
 * tag: 实际使用的element标签
 * placeholder: `${placeholder}${label}` 组成占位提示
 * defaultValue: 默认值，
 * span: element栅格布局使用
 * labelWidth: 标签宽度，若为undefined则不可设置
 * clearable: 输入框组件使用，是否展示清除按钮
 * maxlength: 输入框组件使用，定义最大可输入字符数
 * disabled: 表单是否不可修改
 * required: 是否为必填项
 * regList: 表单校验规则  `
 * proCondition: 是否作为条件判断
 */
export const inputComponents = [
  {
    label: '单行输入框',
    tag: 'el-input',
    placeholder: '请输入',
    defaultValue: undefined,
    span: 24,
    labelWidth: null,
    clearable: true,
    maxlength: null,
    readonly: false,
    disabled: false,
    required: false,
    proCondition: true,
    regList: []
  }
]

export const commonComponents = [...inputComponents]
